import React from "react";
import PropTypes from "prop-types";
import { Button } from "../ui/button";
import StatusBadge from "../shared/badges/Badge";

const HeaderTable = ({ title, count, actions = [], filter }) => {
  const isElement = React.isValidElement(actions);

  return (
    <div className="flex justify-between items-center gap-4 w-full flex-wrap">
      <div className="flex items-center gap-2">
        <h1 className="text-lg font-['Open_Sans'] font-bold capitalize">
          {title}
        </h1>
        {count !== undefined && <StatusBadge status="primary" text={count} />}
      </div>

      <div className="space-x-2 flex items-center capitalize">
        <div>{filter}</div>

        <div className="gap-3 flex">
          {isElement ? (
            actions
          ) : (
            actions.map((action, index) => (
              <Button
                key={index}
                variant={action.variant || "default"}
                className={`${action.className} capitalize text-sm`}
                onClick={action.onClick}
                disabled={action.disabled}
              >
                {action.icon && <action.icon />}
                {action.label}
              </Button>
            ))
          )}
        </div>
        
      </div>
    </div>
  );
};
export default HeaderTable


HeaderTable.propTypes = {
  title: PropTypes.string,
  count: PropTypes.number,
  actions: PropTypes.oneOfType([
    PropTypes.node, // single React element
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.elementType,
        onClick: PropTypes.func,
        variant: PropTypes.string,
        className: PropTypes.string,
      })
    ),
  ]),
  filter: PropTypes.node,
};

